import * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * TODO:
 */
export const copySelected = store.effects.create(
  <TTypeParams extends ec.models.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.copySelected.observe().pipe(
      rxjs.switchMap(action =>
        plugin.collection.plugins.selectionPlugin.feature.actions.getEntities
          .from(action)
          .execute({ portion: 'all' })
          .asObservable.pipe(
            rxjsUtils.latestFrom(result => ({
              context: plugin.collection.feature.selectors.context.asObservable,
              entities: rxjs.of(result.entities),
            })),
            rxjs.map(({ entities, context }) => {
              // FIXME: we shouldn't throw an error here, but filter it out.
              ents.core.admin.Context.ForTenant.assertIsForTenant(context)

              return plugin.config.clipboardService.copy.from(action).create({
                items: entities.map(
                  item =>
                    new plugin.config.pasteClassRef({
                      context,
                      payload: item,
                    }),
                ),
              })
            }),
          ),
      ),
    ),
)
